// 权限拦截在路由跳转  导航守卫
import router from '@/router/router'
import store from '@/store/store'
import myLocalStorage from './config/myLocalStorage'
const whiteList = ['/login', '/register', '/protocol', '/privacyPolicy', '/404', '/empty'] // 定义白名单
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 判断是否有用户数据 用户是否登录
  let flag = store.getters.userRole && store.getters.userRole !== ''
  // console.log('user flag ' + flag)
  // 没有用户数据判断token是否有效
  if (!flag) {
    let token = myLocalStorage.getData('dydnz_access_token')
    flag = token !== ''
  }
  // debugger
  // console.log('beforeEach ', to)
  // token 失效跳转登录页
  if (!flag) {
    // 白名单,不限制...
    if (whiteList.indexOf(to.path) > -1) {
      //  表示要去的地址在白名单
      next()
    } else {
      // window.localStorage.clear()
      next('/login')
    }
  } else {
    let path = to.path
    console.log('path', path)
    let type = 0
    // 白名单 不更新数据
    if (whiteList.indexOf(path) === -1) {
      sessionStorage.jumpUrl = JSON.stringify({path: to.path, query: to.query})
      if (path.startsWith('/qianchuan')) {
        type = 1
        if (localStorage.platformType !== 2) localStorage.platformType = 2
      } else {
        if (localStorage.platformType !== 1) localStorage.platformType = 1
      }
      // 路由名称
      store.commit('getRouteName', path)
      // 左侧路由菜单信息
      store.dispatch('getMenuList', type)
      // console.log('store', store)
      if (!store.getters.userRole) {
        // 判断当前动态路由是否已添加过,暂做保存使用
        // let hasInstantiated = router.resolve({path: to.path}).route.matched.length !== 0
        // console.log('hasInstantiated', hasInstantiated)
        // 用户数据
        try {
          if (!store.getters.userRole) {
            await store.dispatch('getUserInfo')
          }
          if (!store.getters.userRole) {
            throw new Error('getUserInfo')
          }
          if (!store.getters.versionNumber && store.getters.userRole && store.getters.userRole !== 'daoyoudao') {
            await store.dispatch('getVersionInfo')
          }
          // 顶部路由菜单信息
          // let routes = store.getters.routes
          // if (routes.length === 0) {
          //   routes = await store.dispatch('getTopMenuList', type)
          // }
          let routes = []
          if (type === 0) {
            const routes2 = await store.dispatch('getTopMenuList', 1)
            const routes1 = await store.dispatch('getTopMenuList', 0)
            routes = [...routes1, ...routes2]
          } else {
            const routes1 = await store.dispatch('getTopMenuList', 0)
            const routes2 = await store.dispatch('getTopMenuList', 1)
            routes = [...routes1, ...routes2]
          }
          router.addRoutes([...routes, { path: '*', redirect: '/404', hidden: true }])
          // next({path: to.path, query: to.query})
          to.query.t = new Date().getTime()
          next({ ...to, replace: true })
        } catch (error) {
          console.log(error)
          let screeningProduct = localStorage.screeningProduct
          let screeningProject = localStorage.screeningProject
          window.localStorage.clear()
          localStorage.screeningProduct = screeningProduct
          localStorage.screeningProject = screeningProject
          next('/login?error=1')
        }
        // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
      } else {
        // 判断是否需要更新,
        let topath = to.path
        let frompath = from.path
        if ((topath.startsWith('/qianchuan') && !frompath.startsWith('/qianchuan')) || (!topath.startsWith('/qianchuan') && frompath.startsWith('/qianchuan'))) {
          await store.dispatch('getTopMenuList', type)
        }
        next()
      }
    } else {
      // 有token非要去登录页?待处理
      if (to.path === '/login') {
        // 免登录的处理
        let name = ''
        let topMenuList = store.getters.topMenuList
        if (topMenuList.length === 0) {
          console.log('topMenuList')
          await store.dispatch('getTopMenuList')
          name = store.getters.topMenuList[0].name
        } else {
          name = topMenuList[0].name
        }
        if (name) {
          next({name: name})
        } else {
          next()
        }
      } else {
        next()
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js